module.exports = __webpack_public_path__ + "static/media/header1.70cf3692.jpg";